import type { Edge, EdgeChange } from '../types';
import { applyItemChanges } from './applyItemChanges';

const applyEdgeChange = <TEdge extends Edge>(edge: TEdge, change: EdgeChange): TEdge =>
  change.type === 'select' ? { ...edge, selected: change.selected } : edge;

/** Applies `select` / `remove` changes to the app's edges (v11 `applyEdgeChanges`). */
export const applyEdgeChanges = <TEdge extends Edge>(changes: readonly EdgeChange[], edges: readonly TEdge[]): TEdge[] =>
  applyItemChanges(changes, edges, applyEdgeChange);
